import { apiClient } from './apiClient'
import config from '../config/env'

// Tipos para la respuesta de EmailList
export interface EmailListItem {
  emailListId: number
  emailListName: string
  emailListDescription?: string
  vendorId: number
  isDelete: number
  createdAt?: string
  updatedAt?: string
}

export interface EmailListResponse {
  data: EmailListItem[]
  total: number
  start: number
  limit: number
  success: boolean
  message?: string
}

export interface EmailListParams {
  start?: number
  limit?: number
  sort?: string
  dir?: 'ASC' | 'DESC'
  _vendorId?: number
  _isDelete?: number
  genericFilterFields?: string
  genericFilterValue?: string
}

// Función para obtener la lista de emails
export const getEmailList = async (params: EmailListParams = {}): Promise<EmailListResponse> => {
  try {
    const response = await apiClient.get('/EmailList/list', {
      params: {
        start: config.EMAIL_LIST_DEFAULT_START,
        limit: config.EMAIL_LIST_DEFAULT_LIMIT,
        sort: config.EMAIL_LIST_DEFAULT_SORT,
        dir: config.EMAIL_LIST_DEFAULT_DIR,
        _vendorId: config.EMAIL_LIST_VENDOR_ID,
        _isDelete: config.EMAIL_LIST_IS_DELETE,
        genericFilterFields: config.EMAIL_LIST_GENERIC_FILTER_FIELDS,
        genericFilterValue: config.EMAIL_LIST_GENERIC_FILTER_VALUE,
        ...params
      }
    })

    return response.data
  } catch (error: any) {
    console.error('Error fetching email list:', error)
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Error al obtener la lista de emails'
    )
  }
}

// Función para obtener un email específico por ID
export const getEmailListById = async (id: number): Promise<EmailListItem> => {
  try {
    const response = await apiClient.get(`/EmailList/${id}`)
    return response.data
  } catch (error: any) {
    console.error('Error fetching email list by ID:', error)
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Error al obtener el email'
    )
  }
}

// Función para crear un nuevo email list
export const createEmailList = async (data: Partial<EmailListItem>): Promise<EmailListItem> => {
  try {
    const response = await apiClient.post('/EmailList', data)
    return response.data
  } catch (error: any) {
    console.error('Error creating email list:', error)
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Error al crear el email list'
    )
  }
}

// Función para actualizar un email list
export const updateEmailList = async (id: number, data: Partial<EmailListItem>): Promise<EmailListItem> => {
  try {
    const response = await apiClient.put(`/EmailList/${id}`, data)
    return response.data
  } catch (error: any) {
    console.error('Error updating email list:', error)
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Error al actualizar el email list'
    )
  }
}

// Función para eliminar un email list (soft delete)
export const deleteEmailList = async (id: number): Promise<boolean> => {
  try {
    await apiClient.delete(`/EmailList/${id}`)
    return true
  } catch (error: any) {
    console.error('Error deleting email list:', error)
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Error al eliminar el email list'
    )
  }
}

export default apiClient
